// Central config for the AMRA AI Business OS landing page.
// Swap LAUNCH_APP_URL with the production URL of the existing
// AMRA AI Business OS application (amra-invoice-pro) when available.
export const LAUNCH_APP_URL = "https://amra-invoice-pro.emergent.host";
